import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchRates = createAsyncThunk("rates/fetchRates", async () => {
    const { data } = await axios.get(
      "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,litecoin,tether&vs_currencies=rub"
    );
    return {
      BTC: data.bitcoin?.rub || 0,
      LTC: data.litecoin?.rub || 0,
      USDT: data.tether?.rub || 0, 
    };
});